module.exports = __webpack_public_path__ + "img/img-ahorra.79a2457f.webp";